export enum EnumDocuments {
    instructionForAdmin = 'instructionForAdmin',
    instructionForUser = 'instructionForUser',
    technicalSupport = 'technicalSupport',
    systemDescription = 'systemDescription',
    certificateOfRegistration = 'certificateOfRegistration'
}